'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _translate = require('../../language/translate');

var _commonFunctions = require('../../helpers/commonFunctions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validateUsTravelDays(values) {
  return values.application.additional_data.number_of_travel_days_in_the_us >= (0, _moment2.default)(values.application.expiry_date).diff((0, _moment2.default)(values.application.effective_date), 'days');
}

/**
 * Validates the values in the Get Quote portion of the form (the first page).
 * @param {Object} values - The values in the form to validate.
 * @returns {Object} Object of errors found in the form.
 */

exports.default = function (values, props) {
  return {
    applicant: values.applicant.map(function (applicant, i) {
      return {
        dob: !applicant.dob,
        first_name: !applicant.first_name,
        last_name: !applicant.last_name,
        email: i === 0 && !applicant.email,
        additional_data: {
          relationship_to_primary_applicant: i > 0 && !applicant.additional_data.relationship_to_primary_applicant
        }
      };
    }),
    application: {
      effective_date: !values.application.effective_date,
      expiry_date: !(0, _commonFunctions.isMultiTrip)(values) && !values.application.expiry_date,
      additional_data: {
        policy_type: !values.application.additional_data.policy_type,
        state: !values.application.additional_data.state,
        eligibility: !values.application.additional_data.eligibility,
        deductible: !values.application.additional_data.deductible,
        travelling_through_the_us: !(0, _commonFunctions.isMultiTrip)(values) && !(0, _commonFunctions.destinationCA_US)(values) && !values.application.additional_data.travelling_through_the_us,
        number_of_travel_days_in_the_us: !(0, _commonFunctions.isMultiTrip)(values) && !(0, _commonFunctions.destinationCA_US)(values) && values.application.additional_data.travelling_through_the_us === 'yes' && (!values.application.additional_data.number_of_travel_days_in_the_us || validateUsTravelDays(values)),
        number_of_days_per_trip: (0, _commonFunctions.isMultiTrip)(values) && !values.application.additional_data.number_of_days_per_trip,
        destination: !(0, _commonFunctions.isMultiTrip)(values) && !values.application.additional_data.destination
      }
    },
    errors: props.application.quote.information && Array.isArray(props.application.quote.information)
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/v2/validators/canuck/Quote.js
// module id = 1750
// module chunks = 0